export const DomesticMoneyTransferStrings = {
  addBeneficiary: 'Add New Beneficiary',
  selectBeneficiary: 'Select Beneficiary',
  proceedTransfer: 'Proceed to transfer fund',
  beneficiaryFirstName: 'Beneficiary First Name',
  beneficiaryLastName: 'Beneficiary Last Name',
  beneficiaryActNo: 'Beneficiary Account Number',
  confirmBenefeAcc: 'Re enter Beneficiary Account Number',
  bankName: 'Bank Name',
  ifscCode: 'IFSC Code',
  OK: 'OK',
  PRINT_RECEIPT: 'Print Receipt',
  savedBenfeDetails: 'Save beneficiary details',
  beneficiaryDetails: 'Beneficiary Details',
  enterBeneficiaryDetails: 'Enter Beneficiary Details',
  proceed: 'Proceed',
  customerFirstName: 'Customer First Name',
  customerLastName: 'Customer Last Name',
  dob: 'Date of Birth',
  doorNo: 'Door Number/Building Name',
  streetAddress: 'Street/Address Line 1',
  pinCode: 'PIN Code',
  city: 'City',
  state: 'State',
  Occupation: 'Occupation',
  customerDetails: 'Customer Details',
  validateOtp: 'Validate OTP',
  getOtp: 'Get OTP',
  customerValidation: 'Customer Validation',
  customerMobile: 'Customer Mobile Number',
  applicantMobile: "Applicant's Mobile Number",
  enterOtp: 'Enter Otp',
  addNewBeneficiary: 'Add New Beneficiary',
  validateBeneficiaryFor: 'Validate Beneficiary for',
  noBeneficiaryFound: 'No beneficiary found for this Customer, add new beneficiary to proceed further',
  transactionId: 'Transaction ID',
  amount: 'Amount',
  fundTransferSuccess: 'Fund Transferred Successfully',
  initiateNewTrans: 'Initiate New Transaction',
  fundTransferFailedStatus: 'Transaction Failed',
  fundTransferLoading: 'Loading Status',
  proceedToTransfer: 'Proceed to Fund Transfer',
  transferFund: 'Fund Transfer',
  RUPPEE_CONSTANT: '₹',
  beneficiaryName: 'Beneficiary Name',
  beneficiaryAct: 'Beneficiary Account Number',
  transferAmt: 'Transfer Amount',
  Select: 'Select',
  bcAgentUser: 'BC Agent - Confirmation',
  applicableCharges: 'Applicable charges:',
  tradingAccountDebit: 'Your trading balance will be debited by: ',
  confirmTransfer: 'Confirm fund transfer',
  agentMobile: 'Agent Mobile Number',
  beneficiaryValidated: 'Beneficiary Validated Successfully',
  getIFSC: 'Get IFSC Code',
  addIfsc: 'Add IFSC Code',
  unableToFetch: 'Unable to fetch banks!',
  unableToFetchBranch: 'Unable to fetch Branch!',
  unableToFetchCity: 'Unable to fetch City!',
  pleaseSelectFromList: 'Please select the bank from list of banks.',
  branch: 'Branch',
  getIFscCode: 'Validate IFSC Code',
  IFSC_value: 'IFSC Details',
  Mobile: 'Mobile',
  successRegistered: 'Registered Successfully, Please Login.',
  somethingWentWrong: 'Something Went Wrong! Please try again...',
  loading: 'Loading...',
  validAmt: 'Please enter valid amount',
  validExceeedAmt: 'Amount should be less then available limit',
  validatedBene: 'Beneficiary Validated.',
  createNewUser: 'Creating new user!',
  accMismatch: 'Account Number Mismatch!',
  accMatch: 'Account Number Matched!',
  mobRegexString: 'Please enter a valid Mobile Number.',
}
